import SalesAIChat from '@/pages/precios/components/SalesAIChat';
import { useDeviceMode } from '@/hooks/useDeviceMode';
import { useSalesAdvisorState } from './SalesAdvisorProvider';

/**
 * Única instancia visible del asesor de ventas (Alejandro).
 * Consume el contexto publicado por la página actual y se monta
 * una sola vez por layout público.
 */
export default function SalesAdvisor() {
  const { context, openRequest } = useSalesAdvisorState();
  const { isMobile } = useDeviceMode();

  return (
    <SalesAIChat
      context={context}
      openRequest={openRequest}
      bottomOffset={isMobile ? 96 : 24}
    />
  );
}